/**
 * ArticleProgress
 * Tracks scroll position through the article body and writes a CSS
 * custom property `--progress` (0%-100%) to the progress bar element.
 */
export default class ArticleProgress {
	constructor(rootSelector = '[data-article-progress]', bodySelector = '[data-article-body]') {
		this.root = document.querySelector(rootSelector);
		this.body = document.querySelector(bodySelector);
		this.bar = this.root?.querySelector('.article-progress__bar');

		if (!this.root || !this.body || !this.bar) return;

		this.ticking = false;
		this.update = this.update.bind(this);

		window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
		window.addEventListener('resize', this.onScroll.bind(this), { passive: true });
		this.update();
	}

	onScroll() {
		if (this.ticking) return;
		this.ticking = true;
		requestAnimationFrame(this.update);
	}

	update() {
		const rect = this.body.getBoundingClientRect();
		const viewport = window.innerHeight;
		const total = rect.height;
		// distance scrolled past the top of the body
		const scrolled = Math.max(0, -rect.top);
		// the bar fills as the visible reading area progresses
		const readable = Math.max(1, total - viewport * 0.5);
		const progress = Math.min(100, Math.max(0, (scrolled / readable) * 100));
		const value = progress + '%';

		// Set --progress on root so both vertical (height) and horizontal (width)
		// CSS rules can consume it via var(--progress, 0%)
		this.root.style.setProperty('--progress', value);
		this.root.setAttribute('aria-valuenow', String(Math.round(progress)));

		this.ticking = false;
	}
}
